import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GlobalContext } from '../../context/provider';
import showNotification from '../../utilities/showNotification';

import './PaymentSuccess.css'

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isVerifying, setIsVerifying] = useState(true);
  const { authState: { authData } } = useContext(GlobalContext);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    
    if (sessionId) {
      // Show success message
      setTimeout(() => {
        setIsVerifying(false);
        showNotification('🎉 Payment successful! You are now enrolled in the course.', 'success');
        
        // Trigger cart refresh
        window.dispatchEvent(new Event('cartUpdated'));
        
        // Redirect to My Courses after 3 seconds
        setTimeout(() => {
          navigate('/student/dashboard', { state: { activeTab: 'my-courses' } });
        }, 10000);
      }, 1500);
    } else {
      setIsVerifying(false);
      showNotification('Payment verification failed', 'error');
      setTimeout(() => navigate('/cart'), 2000);
    }
  }, [searchParams, navigate]);

  return (
    <div className="payment-success-container">
      {isVerifying ? (
        <div className="verifying-payment">
          <div className="loader"></div>
          <h2>Verifying your payment...</h2>
          <p>Please wait while we process your enrollment</p>
        </div>
      ) : (
        <div className="payment-confirmed">
          <div className="success-icon">✅</div>
          <h1>Payment Successful!</h1>
          <p>You have been enrolled in the course.</p>
          <p className="redirect-message">Redirecting to your courses...</p>
          <button 
            onClick={() => navigate('/student/dashboard', { state: { activeTab: 'my-courses' } })}
            className="btn-go-to-courses"
          >
            Go to My Courses Now
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;